import { GALLERY } from '../../utils/helpers/games/gallery';
import styles from './GamesGallery.module.css';

export default function GamesGallery({ t }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <span className={styles.heading}>{t("game_preview_gallery")}</span>
      </div>

      <div className={styles.grid}>
        {GALLERY.map((game, i) => (
          <div key={i} className={styles.card}>
            <div className={styles.imageWrapper}>
              <img src={game.image} alt="" className={styles.image} />
              <span className={`${styles.tag} ${styles[game.tagColor]}`}>{t(game.tag)}</span>
            </div>
            <div className={styles.info}>
              <span className={styles.title}>{t(game.title)}</span>
              <span className={styles.desc}>{t(game.desc)}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}